import { lazy } from "react";
import { Navigate } from "react-router-dom";

const EnterpriseAdminOverview = lazy(() => import("pages/EnterpriseAdmin/EnterpriseAdminOverview"));

export const admin = [
  {
    path: "admin",
    element: <Navigate to="overview" replace />,
  },
  {
    path: "admin",
    children: [
      {
        path: "overview",
        element: <EnterpriseAdminOverview />,
      },
    ],
  },
];
